import axios from '@/axios/globalaxios'

// 查询班级下的学生
export const findUserByClassId = data =>{
    return axios({
        url: "/tradelab/course/findUserByClassId",
        method: 'post',
        data:data
    })
}
// 移除学生到 课程外
export const eliminateUsers = data =>{
    return axios({
        url: "/tradelab/course/eliminateUsers",
        method: 'post',
        data:data
    })
}
// 移除学生到 课程外
export const findDoesNotExistUserByClassId = data =>{
    return axios({
        url: "/tradelab/course/findDoesNotExistUserByClassId",
        method: 'post',
        data:data
    })
}
// 将用户拉入课程
export const pullInCourse = data =>{
    return axios({
        url: "/tradelab/course/pullInCourse",
        method: 'post',
        data:data
    })
}
// 同步课程下的学生信息
export const syncStudent = data =>{
    return axios({
        url: "/tradelab/financial/viewSchoolCoursesByCourseId",
        method: 'post',
        data:data
    })
}



